import { NgClass } from '@angular/common';
import { Component, Injectable } from '@angular/core';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';

@Injectable({
  providedIn: 'root',
})
export class TiebreakerDetailsView {
  // tieBreakerOverlay = viewChild<OverlayPanel>('ocbView');
  // tieBreakerFor = input<string>(undefined);
  // tieBreakerDetails = input<string>(undefined);
  // displaySize = input<'regular' | 'small' | 'large'>('regular');
  // tieBreakerFullDetails = computed(() => {
  //   return this.deriveDetailedView();
  // });
  constructor() {}

  showTieBreakerDetails(event: MouseEvent) {
    // if (this.tieBreakerOverlay()) this.tieBreakerOverlay().show(event, event.target);
  }

  tieBreakerFor: string = '';
  deriveDetailedView(tieBreakerDetails: string, tieBreakerFor?: string) {
    this.tieBreakerFor = tieBreakerFor;
    if (tieBreakerDetails) {
      const lines = tieBreakerDetails.split(/\r?\n/);
      return lines.map(line => '<p>' + this.processLine(line) + '</p>').join('');
    }
    return tieBreakerDetails;
  }

  processLine(line: string) {
    // Round Totals
    if (line.startsWith('RT')) {
      return this.processRoundTotals(line);
    } else if (line.startsWith('HT')) return this.processHoleTotals(line);
    else if (line.startsWith('PT')) return this.processPT(line);
    else if (line.startsWith('hidx')) return this.processHidx(line);
    return line;
  }

  processRoundTotals(roundTotals: string) {
    const scoreType = roundTotals.startsWith('RT-') ? roundTotals.substring(3, 4) : '';
    const roundNumbersMatch = roundTotals.match(/\[(.*?)\]/);
    const roundNumbers = roundNumbersMatch
      ? roundNumbersMatch[1].split(',').map(r => parseInt(r.trim(), 10))
      : [];
    const scoresMatch = roundTotals.match(/\((.*?)\)/);

    let score1 = 0;
    let score2 = 0;

    if (scoresMatch) {
      // Try splitting by dash first, then by comma if that fails
      const scoresArray = scoresMatch[1].includes('-')
        ? scoresMatch[1].split('-')
        : scoresMatch[1].split(',');

      // Safely parse scores with fallbacks
      score1 = scoresArray[0] ? parseInt(scoresArray[0].trim(), 10) : 0;
      score2 = scoresArray[1] ? parseInt(scoresArray[1].trim(), 10) : 0;
    }

    return (
      this.scoreTypeName(scoreType) +
      ' Totals for Rounds: [' +
      roundNumbers.join(', ') +
      '] = (' +
      score1 +
      '-' +
      score2 +
      ')'
    );
  }

  // processSCTHoleTotals(holeTotals: string) {
  //   const detailsRegex =
  //     /^HT(?:-([GNP]))?\[([^\]]+)\](?:\s*R\[([^\]]+)\])?\s*\((\d+)(?:\s*[-,]\s*(\d+))?\)/;
  //   const matches = holeTotals.match(detailsRegex);
  //   if (!matches) return holeTotals;

  //   const scoreType = matches[1] || '';

  //   // parse holes
  //   const holes = matches[2].includes('-')
  //     ? matches[2].split('-').map(h => parseInt(h.trim(), 10))
  //     : matches[2].split(',').map(h => parseInt(h.trim(), 10));

  //   // parse rounds
  //   const rounds = matches[3] ? matches[3].split(',').map(r => parseInt(r.trim(), 10)) : [];

  //   // parse scores (handles both dash and comma)
  //   const score1 = parseInt(matches[4] || '0', 10);
  //   const score2 = parseInt(matches[5] || '0', 10);

  //   const holeText =
  //     holes.length === 2 ? `Holes ${holes[0]}-${holes[1]}` : `Holes [${holes.join(', ')}]`;
  //   const roundText = rounds.length ? ` for Rounds: [${rounds.join(', ')}]` : '';
  //   const scoreText = ` = (${score1}-${score2})`;

  //   return this.scoreTypeName(scoreType) + ' ' + holeText + roundText + scoreText;
  // }

  processHoleTotals(holeTotals: string) {
    const detailsRegex =
      /^HT(?:-([GNP]))?\[([^\]]+)\](?:\s*R\[([^\]]+)\])?(?:\s*\((\d+)\s*[-,]\s*(\d+)\))?/;
    const matches = holeTotals.match(detailsRegex);
    if (!matches) return holeTotals;
    const scoreType = matches[1] || '';
    const holes = matches[2].includes('-')
      ? matches[2].split('-').map(h => parseInt(h.trim(), 10))
      : matches[2].split(',').map(h => parseInt(h.trim(), 10));
    const rounds = matches[3] ? matches[3].split(',').map(r => parseInt(r.trim(), 10)) : [];
    const [score1, score2] = [parseInt(matches[4] || '0', 10), parseInt(matches[5] || '0', 10)];
    const holeText =
      holes.length === 2 ? `Holes ${holes[0]}-${holes[1]}` : `Holes [${holes.join(', ')}]`;
    const roundText = rounds.length ? ` for Rounds: [${rounds.join(', ')}]` : '';
    const scoreText = ` = (${score1}-${score2})`;
    return this.scoreTypeName(scoreType) + ' ' + holeText + roundText + scoreText;
  }
  processPlayerTotals(playerTotals: string) {
    const detailsRegex = /^PT(?:-([GNP]))?\[([^\]]+)]\s*\((\d+)\s*-\s*(\d+)\)/;
    const matches = playerTotals.match(detailsRegex);
    if (!matches) return playerTotals;
    const scoreType = matches[1] || '';
    const playerPositions = matches[2].split(',').map(p => parseInt(p.trim(), 10));
    const [total1, total2] = [parseInt(matches[3], 10), parseInt(matches[4], 10)];
    const positionText =
      playerPositions.length === 1
        ? `Position ${playerPositions[0]}`
        : `Positions [${playerPositions.join(', ')}]`;
    return `${this.scoreTypeName(scoreType)} Totals for Players at Position ${positionText} = (${total1}-${total2})`;
  }
  processPT(playerTotals: string) {
    const detailsRegex = /^PT(?:-([GNP]))?\[([^\]]+)](?:\s*R\[(\d+)])?\s*\((\d+)\s*[-,]\s*(\d+)\)/;
    const matches = playerTotals.match(detailsRegex);
    if (!matches) return playerTotals;
    const scoreType = matches[1] || '';
    const playerPositions = matches[2].split(',').map(p => parseInt(p.trim(), 10));
    const roundNo = matches[3] ? parseInt(matches[3], 10) : null;
    const [total1, total2] = [parseInt(matches[4], 10), parseInt(matches[5], 10)];
    const positionText =
      playerPositions.length === 1
        ? `Position ${playerPositions[0]}`
        : `Positions [${playerPositions.join(', ')}]`;
    const roundText = roundNo ? ` in Round ${roundNo}` : '';
    return `${this.scoreTypeName(scoreType)} Totals for Players at ${positionText}${roundText} = (${total1}-${total2})`;
  }
  processHidx(line: string) {
    const detailsRegex = /^hidx(Low|High)\s*\((\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)\)/;
    const matches = line.match(detailsRegex);
    if (!matches) return line;
    const label = matches[1] === 'Low' ? 'Low Handicap Index' : 'High Handicap Index';
    return `${label} (${matches[2]} - ${matches[3]})`;
  }
  private scoreTypeName(scoreType: string) {
    switch (scoreType) {
      case 'G':
        return 'Gross';
      case 'N':
        return 'Net';
      case 'P':
        return 'Stableford Point';
      default:
        if (this.tieBreakerFor === 'Any') return 'Positional Point';
        return this.tieBreakerFor;
    }
  }
}
